import { combineReducers } from "redux";
import widgetsReducers from "./widgets/widgets.reducers";
import googleReducers from "./google/google.reducers";

export default combineReducers({
	widgets: widgetsReducers,
	googleStore: googleReducers,
});
